<template>
  <div class="page">
    <div class="flex items-c just-b">
      <div>
        <span class="content-tit">
          评测统计
        </span>
        <el-radio-group v-model="tabPosition" class="ml30" @change="tabChange">
          <el-radio-button :label="1">群体分析</el-radio-button>
          <el-radio-button :label="2">群体对比</el-radio-button>
          <el-radio-button :label="3">群体趋势</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div>
      <Page1 v-if="tabPosition === 1" ref="page1" :tab-position="tabPosition" />
      <Page2 v-if="tabPosition === 2" :tab-position="tabPosition" />
      <Page3 v-if="tabPosition === 3" :tab-position="tabPosition" />
    </div>
  </div>
</template>

<script>
import Page1 from './page1.vue'
import Page2 from './page2.vue'
import Page3 from './page3.vue'
export default {
  components: {
    Page1,
    Page2,
    Page3
  },
  data() {
    return {
      tabPosition: 1
    }
  },
  created() {
    let params = ''
    if (localStorage.getItem('searchParams')) {
      params = JSON.parse(localStorage.getItem('searchParams'))
    }
    if (params && params.tabPosition) {
      this.tabPosition = params.tabPosition
    }
  },
  methods: {
    tabChange() {
      localStorage.setItem('searchParams', null)
    }
  }
}
</script>

<style lang="scss" scoped >

  .panel-wrap{
    padding: 20px 30px;
    background: #F6F6F6;
    border-radius: 10px;
    width: 800px;
  }
  .item{
    width: 360px;
    height: 380px;
    position: relative;
  }
  .panel-content{
    padding: 20px;
  }
  .score{
    .number{
      color: #FB834D;
      font-size: 40px;
    }
  }
  .c-score{
    color: #FB834D;
  }
</style>
